import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalCourseStore from '../../../../../../stores/global-course-store';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteAssignmentIdOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  assignmentId: number | undefined,
  setLoading: (isLoading: boolean) => any,
) => {
  try {
    if (!programId || !courseId || !assignmentId) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }

    setLoading(true);

    const res = await appApi.deleteAssignment(
      programId,
      courseId,
      assignmentId,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setLoading(false);

    globalCourseStore.updateCourseDetails(
      courseId,
      res.data.body.metadata,
      res.data.body.details,
    );
    /*globalCourseStore.addCourseMetadata(res.data.body.metadata);

    globalCourseStore.addCourseDetails(courseId, res.data.body.details);
    globalCourseStore.currentId = courseId;*/
  } catch (e) {
    setLoading(false);
    console.error(
      `deleteAssignmentIdOperation is failed with the programId: ${programId}, courseId: ${courseId}, assignmentId: ${assignmentId} with the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
